<!-- ocr到期的底部弹窗 -->
<template>
  <van-popup
    :show="show"
    class="seal-pop-box"
    position="bottom"
    :style="{'border-radius': '8px 8px 0px 0px'}"
  >
  <div class="box" :style="getStyleHeight">

    <!-- 内容部分 -->
    <div class="pop-content-box">
      <div class="pop-title">
        <div class="left-title">功能到期提醒</div>
        <div class="right-clear" v-if="clearShow" @click="$emit('submit')">关闭</div>
      </div>

      <div class="pop-main-box">
        <img class="warn-img" src="@/assets/images/Details/ocr-warn.png" alt="">
        <div class="warn-title">OCR功能已到期</div>
        <div class="warn-title">请联系管理员购买OCR功能</div>
      </div>
    </div>
    <!-- 按钮部分 -->
    <div class="pop-but-box" :style="getStyleObj">
      <div class="submit" @click="$emit('submit')">确定</div>
    </div>
  </div>
  </van-popup>
</template>

<script setup>
import { defineProps,computed } from "vue";
const props = defineProps({
  // 是否展示
  show: {
    type: Boolean,
    default: false,
    required: true,
  },
  // 是否展示关闭按钮
  clearShow: {
    type: Boolean,
    default: false,
  },
  // 根据类型来判断 背景渐变色和图片信息部分样式 1：红 2：蓝
  type: {
    type: Number,
    default: 1,
  },
  info: {
    type: Object,
    default: () => ({}),
  },
});
const getStyleObj = computed(()=>{
  let u = window.navigator.userAgent;
  let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // true 为IOS终端
  return ios ? {} : { paddingBottom:'12px' }
})
const getStyleHeight = computed(()=>{
  let u = window.navigator.userAgent;
  let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // true 为IOS终端
  return ios?{} :{height:'345px'}
})
const emits = defineEmits(["submit", "clear"]);
console.log(props, emits);
</script>
<style scoped lang="less">
@import "./index.less";
</style>
